<div class="flex items-center gap-6 justify-center mb-8">
  <button (click)="prevPage()" [hidden]="currentPage === 1" class="cursor-pointer">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="m12 19-7-7 7-7"/>
      <path d="M19 12H5"/>
    </svg>
  </button>
  <span class="space-x-6">Pagina {{ currentPage }} di {{ totalPages }}</span>
  <button (click)="nextPage()" [hidden]="currentPage === totalPages" class="cursor-pointer">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 12h14"/>
      <path d="m12 5 7 7-7 7"/>
    </svg>
  </button>
</div>

